/**
 * @generated SignedSource<<500f668a6485d58072065041ec21ce9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineOccasionListItem_item$data = {
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_Routine">;
  };
  readonly sequenceNumber: number;
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion" | "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion" | "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion">;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineOccasionListItem_item";
};
export type WidgetTeamScheduleRoutineOccasionListItem_item$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineOccasionListItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineOccasionListItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineOccasionListItem_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionStatusCircle_RoutineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequenceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleRoutineListItemContent_Routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "aea4c12531e4858a65bd36a064437c0a";

export default node;
